module.exports = __webpack_public_path__ + "img/feed-schedule.6b3e338a.svg";